import { Component, OnInit, ViewChild, ElementRef } from '@angular/core';
import { gutil} from '../gutil';
import { HttpClient } from '@angular/common/http'
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ActivatedRoute, Router } from '@angular/router';
import { faMapMarker } from '@fortawesome/free-solid-svg-icons';
import { MapsAPILoader } from '@agm/core';

@Component({
  selector: 'app-searchlist',
  templateUrl: './searchlist.component.html',
  styleUrls: ['./searchlist.component.scss']
})
export class SearchlistComponent implements OnInit {

  public faMapMarker = faMapMarker;

  public propertySel : any;
  public genderSel : any;
  public radiusSel : any;

  public citySel : any;
  // public searchData = {address: "", sharetype: 4, gender: 3,radius:0, city: "", lat:0,long:0};
  public propertyData : any;
  public propertyDetail : any;
  public searchText : any;
  public paramsText : any;
  public selectedRadius: number;
  public selectRadius : Array<any>;
  public params: any;
  public totalProperty: any;
  public loader : boolean;
  public stateText: string;
  public timelist: any;
  public selectedCity : string;
  public selectedGender: number;
  public selectedShareType : number;
  public proptypeText: any;
  public addressActive: string;
  public getRoutes:any;

  @ViewChild("search")
  public searchElementRef: ElementRef;

  constructor(private http: HttpClient, private modalService: NgbModal, private routeact: ActivatedRoute, private router: Router, private mapsAPILoader : MapsAPILoader) {

    this.radiusSel = gutil.radiusSel;
    this.propertySel = gutil.propTypeList;
    this.genderSel = gutil.genderSel;
    this.citySel = gutil.citySel;
    this.timelist = gutil.timelist;
    this.selectedCity = gutil.searchData.city;
    this.selectedGender = gutil.searchData.gender;
    this.selectedShareType = gutil.searchData.sharetype;
    this.selectedRadius = gutil.searchData.radius;
   }

  ngOnInit(): void {
    window.scroll(0,0);
    // this.changeURLs();
    this.routeact.params.subscribe((params) => {
      /////Gender/////////////////////
      if(params.gender == 'Boys') {
        gutil.searchData.gender = 1;
      }
      else if(params.gender == 'Girls') {
        gutil.searchData.gender = 2;
      }
      else if(params.gender == 'All') {
        gutil.searchData.gender = 3;
      } 
      else {
        
      }
      ////////Address///////////////////
      if(gutil.searchData.address != "" || gutil.searchData.address !== undefined){
        gutil.searchData.city = params.city;
        if(params.city == 'bengaluru'){
          this.stateText = 'Karnataka';
        }else{
          this.stateText = "Maharashtra";
        }
        if(params.location == undefined){
          gutil.searchData.address = params.city.charAt(0).toUpperCase() + params.city.slice(1) + ', ' + this.stateText + ", " + "India";

        }
        else if(params.location == "All" || params.location == "Boys" || params.location == "Girls") {
          if(params.location == "All") {
            gutil.searchData.gender = 3;
          }
          gutil.searchData.address = params.city.charAt(0).toUpperCase() + params.city.slice(1)+ ', '+ this.stateText + ", " + "India";
        }
        else{
          
          gutil.searchData.address =params.location  + ', ' + params.city.charAt(0).toUpperCase() + params.city.slice(1) + ', ' + this.stateText + ", " + "India";

        }
      }
      
    });
    this.selectedRadius = 0;
    this.getData();

    //autocomplete
    this.mapsAPILoader.load().then(() => {
      let options :google.maps.places.AutocompleteOptions;
      options = {
        componentRestrictions: {country : 'in'}
      }
      let autocomplete = new google.maps.places.Autocomplete(this.searchElementRef.nativeElement , options);
      autocomplete.addListener("place_changed", () => {
          this.addressActive = autocomplete.getPlace().formatted_address;
          gutil.searchData.address = this.addressActive;
          this.newData();
      });
    });
    

    this.loader = true;
  }
  
  changeAddress(value: any) {
    gutil.searchData.address = value;
    this.getData();
    // this.fetchRoutes();
  }
  changeCity(value: any) {
    gutil.searchData.city = value;
    gutil.searchData.address = gutil.searchData.city.charAt(0).toUpperCase() + gutil.searchData.city.slice(1) + ', ' + this.stateText + ", " + "India";
    this.addressActive = gutil.searchData.address;
    this.newData();
    // this.fetchRoutes();
  }
  changeGender(value: any) {
    gutil.searchData.gender = value;
    this.getData();
    this.fetchRoutes();
  }
  changeRadius(value: any) {
    gutil.searchData.radius = value;
    this.getData();
  }
  public getData() {


    for(let i=0;i<gutil.radiusSel.length;i++){
      if(gutil.searchData.radius == gutil.radiusSel[i].id){
        this.selectRadius = [gutil.radiusSel[i]];
      }
    }
    
    // if(this.selectedCity != gutil.searchData.city){
    //   console.log("HIIIIIIIII")
    //   gutil.searchData.address = gutil.searchData.city.charAt(0).toUpperCase() + gutil.searchData.city.slice(1) + ', ' + this.stateText + ", " + "India";
    // }
    if(gutil.searchData.gender == 3){
      gutil.searchData.gender = 0;
    }
    if(gutil.searchData.sharetype == 4){
      gutil.searchData.sharetype = 0;
    }

    this.selectedCity = gutil.searchData.city;
    this.selectedGender = gutil.searchData.gender;
    this.selectedRadius = gutil.searchData.radius;
    this.addressActive = gutil.searchData.address;

    this.loader = true;
    
    this.http.get('https://api.yourownroom.com/api/w/v1/search/property?' + gutil.filterSearch())
        .subscribe((data: any)=> {
          this.propertyData = data.data;
          this.totalProperty = data.total;
          if(this.propertyData.length > 0){
            let minRoomRent = 0;
              let maxRoomRent = 0;
              let discountpropRent =0;
              let roomRent = 0;
              let mindiscountRoomRent = 0;
              let maxdiscountRoomRent = 0;
              let discountpercent = 0;
              let propRent=0;let countRecs: number = 0;
              for(let i = 0 ; i < this.propertyData.length; i++){
                  this.propertyData[i].property.formatted_details = this.propertyData[i].property.details.substring(0, 80);
                  propRent=0;
                  minRoomRent = 0;
                  maxRoomRent = 0;
                  roomRent = 0;
                  mindiscountRoomRent = 0;
                  maxdiscountRoomRent = 0;
                  discountpropRent = 0;
                  discountpercent = 0;
                  
                  for(let j=0; j< this.propertyData[i]['property']['rooms'].length;j++){
                    if(this.propertyData[i]['property']['rooms'][j].status=="available"){
                        countRecs = countRecs+1;
                    }
                    if(this.propertyData[i]['property']['rooms'][j].totalbed > 1){
                        roomRent = Number(this.propertyData[i]['property']['rooms'][j].rent/this.propertyData[i]['property']['rooms'][j].totalbed);
                    } else {
                        roomRent = Number(this.propertyData[i]['property']['rooms'][j].rent);
                    }
                    if(minRoomRent== 0 || minRoomRent >= roomRent){
                      minRoomRent =  roomRent;
                    }
                    if(maxRoomRent <= roomRent){
                      maxRoomRent =  roomRent;
                    }
                }

                for(let d=0; d< this.propertyData[i]['property']['campaignproprel'].length;d++){
                    discountpercent = this.propertyData[i]['property']['campaignproprel'][d].discountamount
                }

                propRent=this.propertyData[i]['property'].rent;
                mindiscountRoomRent = minRoomRent - (minRoomRent*(discountpercent/100));
                maxdiscountRoomRent = maxRoomRent - (maxRoomRent*(discountpercent/100));
                discountpropRent = propRent - (propRent*(discountpercent/100));
                if(minRoomRent == maxRoomRent){
                    this.propertyData[i]['property'].dispRent = "₹"+minRoomRent;
                    this.propertyData[i]['property'].discountdispRent = "₹"+mindiscountRoomRent;
                }
                else{
                    this.propertyData[i]['property'].dispRent = "₹"+minRoomRent+ "-₹"+ maxRoomRent;
                    this.propertyData[i]['property'].discountdispRent = "₹"+ mindiscountRoomRent + "-₹" + maxdiscountRoomRent;
                }
                if(this.propertyData[i]['property']['rooms'].length == 0){
                    this.propertyData[i]['property'].dispRent = "₹"+ propRent;
                    this.propertyData[i]['property'].discountdispRent = "₹"+ discountpropRent;
                }
                this.propertyData[i]['property'].name = this.propertyData[i]['property'].name.substr(0,40) + (this.propertyData[i]['property'].name.length > 40 ? " ..." : "");
                  this.propertyData[i]['property'].dispGender = gutil.genderList[this.propertyData[i]['property'].gender];
                  this.propertyData[i]['property'].dispStatus = gutil.propStatus[this.propertyData[i]['property'].status];
                  
            }
          }else{
            this.router.navigate(['/'+gutil.searchData.city+'/properties-for-rent/']).then(() => {
              window.location.reload();
            });
          }
          this.loader = false;
        })
  }

  public newData(){
    this.loader = true;
    var loc = this.addressActive.substring(0 , this.addressActive.indexOf(",")).replace(" ",'-');
    if(loc.toLowerCase() !== gutil.searchData.city.toLowerCase()){
        this.router.navigate(['/'+gutil.searchData.city+'/properties-for-rent/'+loc]).then(() => {
          window.location.reload();
        });
    }
    else{
        this.router.navigate(['/'+gutil.searchData.city+'/properties-for-rent/']).then(() => {
          window.location.reload();
        });
    }
  }

  public fetchRoutes() {
    var loc = this.addressActive.substring(0 , this.addressActive.indexOf(",")).replace(" ",'-');
    var getGen: any;
    var getShartType:any;
      if(gutil.searchData.gender == 1) {
        getGen = "Boys";
      }
      else if(gutil.searchData.gender == 2) {
        getGen = "Girls";
      }
      else {
        getGen = "All";
      }
      ////// sharetype///
      if(gutil.searchData.sharetype == 1) {
        getShartType = "Co-Living"; 
      }
      else if(gutil.searchData.sharetype == 3) {
        getShartType = "Family";
        gutil.searchData.gender = 0;
      }
      else {
        getShartType = "All";
      }
      
      if(loc.toLowerCase() !== gutil.searchData.city.toLowerCase() ){
        this.router.navigate(['/'+gutil.searchData.city+'/properties-for-rent/'+ loc +'/' + getShartType + '/' + getGen ]);
      }
      else {
        if(loc == "Family" || loc == "Co-Living") {
          getShartType = gutil.searchData.city;
          this.router.navigate(['/'+gutil.searchData.city+'/properties-for-rent/' +getShartType + '/' + getGen]);
        }
        else if(loc == "Pune" || loc == "Bengaluru") {
          if(getShartType == "Family" || getShartType == "Co-Living") {
            var locality = "All";
            this.router.navigate(['/'+gutil.searchData.city+'/properties-for-rent/'+locality + '/' + getShartType]);
          }
          else {
            this.router.navigate(['/'+gutil.searchData.city+'/properties-for-rent/'+ getShartType + '/'+getGen ]);          
          }
        }
        else {
          this.router.navigate(['/'+gutil.searchData.city+'/properties-for-rent/'+ loc +'/' + getShartType + '/' + getGen ]);
        }
      }
    
  }
  
}
